export default function ProspectPhoneSearchResults({ results, onOpen }) {
  if (!results.length) return null;
  return <section aria-label="Resultados da busca na Prospecção" style={{
    background:"#EFF6FF", border:"1px solid #DBEAFE", borderRadius:10, padding:12, marginBottom:16,
  }}>
    <div style={{ fontWeight:700, fontSize:13, marginBottom:8 }}>Encontrado na Prospecção</div>
    {results.map(record => <button type="button" key={`${record.storeId}:${record.id}`}
      onClick={() => onOpen(record)} style={{
        display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", width:"100%", textAlign:"left",
        background:"#fff", color:"#334155", border:"1px solid #DBEAFE", borderRadius:8,
        padding:"9px 12px", marginTop:6, cursor:"pointer", fontSize:13,
      }}>
      <strong>{record.name || record.phone || record.telefone}</strong>
      <span>Prospecção</span>
      <span>{record.phone || record.telefone}</span>
      <span style={{ marginLeft:"auto", color:"#1D4ED8", fontWeight:700 }}>Abrir cartão →</span>
    </button>)}
  </section>;
}
